/* ======================================================================== */
/* 60. animateWords */
/* ======================================================================== */
function animateWords($target, duration = 1.2, stagger = 0.01, reverse, masterStagger) {

	var masterTL = new TimelineMax();

	if ($target.length) {

		$target.each(function () {

			var
				tl = new TimelineMax(),
				$chars = $(this).find('.split-chars__char');

			if (reverse) {
				$chars = $chars.get().reverse();
			}

			if (!masterStagger) {
				masterStagger = '-=' + duration;
			}

			tl.staggerTo($chars, duration, {
				x: '0px',
				y: '0px',
				autoAlpha: 1,
				ease: Power4.easeOut
			}, stagger);

			masterTL.add(tl, masterStagger);

		});

	};

	return masterTL;

}
